import { BrandQuery, BrandsQuery, Record } from '~/Api/Analytics/VirtualBrand/History';
import Pagination from '~/Api/Pagination/Pagination';

import ActionTypes from './ActionTypes';

export type Query = { id?: string; key: string };

interface HistoryState {
	request: Promise<any>;
	isFetching: boolean;
	query: Query;
	items: Record[] | null;
	pagination: Pagination | null;
}

export interface State {
	byQuery: { [key: string]: HistoryState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			query: Query;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			query: Query;
			items: null;
			pagination: null;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			query: Query;
			items: Record[];
			pagination: Pagination;
	  }
	| {
			type: ActionTypes.prune;
			query: Query;
	  };

function createState(): State {
	return { byQuery: {} };
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byQuery: {
					...state.byQuery,
					[action.query.key]: {
						...(selectHistory(state, action.query) || {
							items: null,
							pagination: null,
						}),
						request: action.request,
						isFetching: true,
						query: action.query,
					},
				},
			};

		case ActionTypes.receive: {
			const historyState = selectHistory(state, action.query);
			if (!historyState || historyState?.request !== action.request) {
				return state;
			}
			if (!action.items) {
				const byQuery = { ...state.byQuery };
				delete byQuery[action.query.key];
				return { ...state, byQuery };
			}

			const items = historyState.items ? [...historyState.items] : [];
			items.splice(action.pagination.getFirstIndex(), action.pagination.perPage, ...action.items);

			return {
				...state,
				byQuery: {
					...state.byQuery,
					[action.query.key]: {
						...historyState,
						isFetching: false,
						items,
						pagination: action.pagination,
					},
				},
			};
		}

		case ActionTypes.prune: {
			const byQuery = { ...state.byQuery };
			delete byQuery[action.query.key];
			return { ...state, byQuery };
		}

		default:
			return state;
	}
}

export function selectHistory(state: State, query: Query): HistoryState | null {
	return state.byQuery[query.key] ?? null;
}
